import * as React from 'react';
import { ReactComponent as DoctorIconSVG } from '../../assets/icons/mevo/ic_doctor_principal.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DoctorIconPrincipal: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DoctorIconSVG} variantPlaces={1} baseColor="#ffffff" {...props} />;
};

export default DoctorIconPrincipal;
